/**
 * 자격증 시험 상세 정보
 */
export class ExamDetail {
  /**
   * @param {number} id - 자격증 시험 아이디
   * @param {string} name - 시험 이름
   * @param {string} certificationCode - 자격증 코드
   * @param {string} examCode - 시험 코드
   * @param {Date} startAt - 시작 일시
   * @param {Date} finishAt - 종료 일시
   * @param {number} questionCount - 문항수
   * @param {number} totalScore - 총점
   * @param {string} testLink - 시험 링크
   * @param {number} certificationId - 자격증 아이디
   * @param {number} examFee - 응시료
   * @param {string} state - 상태 (Allowed: DRAFT┃ANNOUNCED┃CLOSED┃PREPARED┃DROPPED┃IN_PROGRESS┃WAITING_COMPLETION┃FINISHED)
   */
  constructor(data) {
    this.id = data.id
    this.name = data.name
    this.certificationCode = data.certificationCode
    this.examCode = data.examCode
    this.startAt = data.startAt
    this.finishAt = data.finishAt
    this.questionCount = data.questionCount
    this.totalScore = data.totalScore
    this.testLink = data.testLink
    this.certificationId = data.certificationId
    this.examFee = data.examFee
    this.state = data.state
  }
}
